import type { ConnectedPosition } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

import type { AlignValue, OverlayPosition, AlignMenuController } from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';

import { AlignMenuComponent } from './align-menu.component';

@Injectable()
export class AlignMenuService
  extends WysiwygComponentPortalService<AlignMenuComponent>
  implements AlignMenuController
{
  protected overlayConfig = {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
  };

  public open(
    position: OverlayPosition | DOMRect,
    _options: {
      getActive: () => AlignValue;
      select: (val: AlignValue) => void;
      preferredPositions?: ConnectedPosition[];
    },
  ) {
    const options = {
      preferredPositions: _options.preferredPositions || [
        { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom' },
      ],
    };
    this.close();
    this.openComponent(AlignMenuComponent, position, options.preferredPositions, {
      skipComponentCD: true,
    });
    const { instance, location } = this.componentRef!;
    instance.close = () => {
      this.close();
    };
    instance.getActive = _options.getActive;
    instance.select = _options.select;
    this.componentRef?.changeDetectorRef?.detectChanges();
    return {
      element: <HTMLElement>location.nativeElement,
      backdropClick$: this.overlayRef!.backdropClick(),
    };
  }
}
